/**
 * @property {boolean} isContact
 * @property {string} map.users
 */
export default class Permission {
    constructor() {
        this.isContact = false;
        this.map = {
            users: Permission.accessNone,
            textbases: Permission.accessNone,
            permissions: Permission.accessNone
        };
    }

    /**
     * @return {Boolean}
     */
    get hasAny(){
        for(let i in this.map){
            if(this.map[i] !== Permission.accessNone){
                return true;
            }
        }
        return false;
    }
    /**
     * @return {string}
     */
    static get accessNone() {
        return "-";
    }

    /**
     * @return {string}
     */
    static get accessRead() {
        return "r";
    }

    /**
     * @return {string}
     */
    static get accessReadWrite() {
        return "rw";
    }

    /**
     * Returns a new `Permission` instance hydrated with data from given `api_resource`.
     *
     * @param {object} api_resource
     * @return {Permission}
     */
    static fromAPI(api_resource) {
        const out = new Permission();
        return Object.assign(out, {
            isContact: api_resource.isContact,
            map: Object.assign(out.map, api_resource.map)
        });
    }
}
